import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setpassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const adminEmail = "namnadunammakkall@gmail.com";
  const adminPassword = "12345";

  const handleadminlogin = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      if (email === adminEmail && password === adminPassword) {
        localStorage.setItem("isAdminLoggedIn", true);
        navigate("/admin");
      } else {
        setError("Invalid Email or Password!");
      }
      setLoading(false);
    }, 1500);
  };

  return (
    <div className="admin-login-container">
      <div className="login-box">
        <h2 className="login-title">Admin Login</h2>

        <form onSubmit={handleadminlogin}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="error-msg">{error}</p>}

          <button className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
